<div class="loader-base" *ngIf="isLoading| async">
	<div class="loader"></div>
</div>